import React from 'react';
import './ComponentsCss/NewsItemExpand.css';
import { useLayoutEffect, useEffect, useState, useRef, useCallback } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// react slick (sider) 
import Slider from "react-slick";
// axios 
import axios from 'axios';
// lawyer card 
import LawyerCard from './LawyerCard';
// lawyer img 
import ProfileImg from '../imgs/NewsExpandImgs/profile.png';
// poa modal
import POAModal from './POAModal.js';

import useAuth from '../hooks/useAuth.js';
import toast, { Toaster } from 'react-hot-toast';
const errNotify = (Text) => toast.error(Text);
const Notify = (Text) => toast.success(Text);

const NewsItemExpand = ({ mainImgSrc, title, description, goalSupp, jointNo, suppNo, descImg, onGoing, lawyerId }) => {

    const { auth } = useAuth();
    const [POA, SetPOA] = useState(false);
    // modal call back 
    const [POAModalOpen, SetPOAModalOpen] = useState(false);
    const [POAData, SetPOAData] = useState();

    const POAOpenStateCallBack = useCallback((POAModalOpen) => {
        SetPOAModalOpen(POAModalOpen);
        SetPOA(POAModalOpen);
    }, [POAModalOpen]);
    const POADataCallBack = useCallback((POAData) => {
        SetPOAData(POAData);
        //alert("Received data " + ModalData);
    }, [POAData]);

    // lawyer data 
    const [LawyerData, SetLawyerData] = useState();
    const [supprtPerc, SetSupportPerc] = useState(0);
    const buttonScrollRef = useRef();
    const el = useRef();
    const q = gsap.utils.selector(el);
    useLayoutEffect(() => {
        const ctx = gsap.context((self) => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: el.current,
                    start: "top top",
                    end: "+=300",

                    //invalidateOnRefresh : true,  // color change error on refresh 
                    //    refreshPriority: 1,
                    //markers: true,   
                    scrub: 1,

                    //pin: true, //  causing pinning problem (moves after end ) 
                }
            }).fromTo(q("#buttonScroll"), {
                opacity: 0,
            }, {
                opacity: 1,
            });

        }, el); // <- Scope!
        return () => ctx.revert(); // <- Cleanup!
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    // slider settings 
    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };

    useEffect(() => {
        if(goalSupp == 0 ) {
            SetSupportPerc(0);     
        }else{
            SetSupportPerc((jointNo / goalSupp) * 100);
        }
        
      
        axiosLawyerData();
    }, []);


    useEffect(() => {
        //console.log(JSON.stringify(LawyerData, null ,2 ));
    }, [LawyerData]);
    const axiosLawyerData = async () => {
        //console.log(" axiosLawyerData ");
        const controller = new AbortController();
        var finalIP = "";
        // https://stepupkorea.kr/api/NewsList/getAllNews
        finalIP = "https://stepupkorea.kr/api/Lawyer/lawyerData";
        try {
            const response = await axios.get(finalIP
                , {
                    signal: controller.signal,
                    params: {
                        lawyerId: lawyerId
                    }
                }
            );
            if (response) {
                //console.log(response.data);
                SetLawyerData(response.data);
                //SetNewsListsArray(response.data);
            } else {

            }

        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Missing Username or Password');
            } else if (err.response?.status === 401) {
                console.log('--Unauthorized');
            } else {
                console.log('ERR');
            }

        }
    }
    function onClickPOA() {
        if (auth?.accessToken) {
            console.log("Logged in ");
            SetPOA(!POA);
        } else {
            errNotify("허위 정보 작성 방지를 위해<br> 로그인 후 참여 가능합니다");
            SetPOA(false);
            console.log("Not logged in");
        }
    }

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    return (
        <div className='news-expand-flex-col' ref={el}>
            {
                POA ? <POAModal ModalOpenCallBack={POAOpenStateCallBack} ModalDataCallBack={POADataCallBack} /> : null
            }
            <div className='news-responsive-box '>
                <div className='news-expand-button-flex' ref={buttonScrollRef}
                    id="buttonScroll">
                    <div className='news-expand-button-type1' onClick={() => onClickPOA()}> 공동고발 참여하기 </div>
                    <div className='news-expand-button-type2' onClick={() => openInNewTab("https://www.ihappynanum.com/Nanum/B/IMMM3QZ6I4")}> 공동고발 응원하기 </div>
                </div>

                <img src={"https://stepupkorea.kr/images/news-lists/main/" + mainImgSrc} className='news-expand-main-img' />

                <div className='news-expand-title'> {title} </div>
                <div className='news-expand-desc'> {description} </div>
                <div className='news-expand-flex-row' style={{ color: "var(--mainLightAccentColor)" }}>
                    <div className='news-expand-big-text'> {supprtPerc.toLocaleString(undefined, { maximumFractionDigits: 0 })} %</div>
                    <div> 달성</div>
                    <div className='news-expand-button-type3'>{
                        onGoing == 1 ? "진행중" : "종료됨"
                    }</div>
                </div>
                <div className='news-expand-xsmall-text'>
                    전체 고발 목표인원 {goalSupp} 명
                </div>

                <div className='news-expand-big-text'>
                    {jointNo.toLocaleString(undefined, { maximumFractionDigits: 0 })}
                </div>
                <div className='news-expand-small-text'>
                    공동고발 인원
                </div>

                <div className='news-expand-big-text'>
                    {suppNo.toLocaleString(undefined, { maximumFractionDigits: 0 })}
                </div>
                <div className='news-expand-small-text'>
                    응원 인원
                </div>
            </div>
            <div className="news-expand-slick-container">

                <Slider {...settings}>
                    <div className='news-expand-banner'>
                        📢 공동고발을 위해서는
                        회원가입이 필수입니다!
                    </div>

                    <div className='news-expand-banner'>
                        ✉️ '새소식' 페이지를 통해 지속적으로
                        진행상황을 알려드립니다!
                    </div>
                </Slider>
            </div>

            <div className='news-responsive-box '>
                {
                    LawyerData ?
                        <LawyerCard lawyerData={LawyerData} /> : null
                }

                <div className='news-expand-big-text'>
                    사건 소개
                </div>
                <img src={"https://stepupkorea.kr/images/news-lists/desc/" + descImg} className='news-expand-main-img' />

            </div>
            <div style={{ marginBottom: "150px" }}>

            </div>
        </div>
    )
}

export default NewsItemExpand